import React from 'react';
import { Target, Heart, Globe, Award } from 'lucide-react';

const About: React.FC = () => {
  const features = [
    {
      icon: Target,
      title: 'Our Mission',
      description: 'To secure and connect people by making their communities safer, ensuring better commutes and cleaner cities and giving peace of mind when the children go off to school.'
    },
    {
      icon: Heart,
      title: 'Our Passion',
      description: 'We believe that local solutions are better for local challenges when communities pool together to share in that solution with the help of our technology.'
    },
    {
      icon: Globe,
      title: 'Our Customer',
      description: 'We are focused on our customer. We want to learn from them more ways our technology can help them and their communities share in the solutions to make their lives and environment better.'
    },
    {
      icon: Award,
      title: 'Our Commitment',
      description: 'We are committed to innovating the solutions that make people connect and share more to improve their lives and make their communities and environment better.'
    }
  ];

  return (
    <div className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">About Tripp</h2>
          <div className="w-24 h-1 bg-green-700 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Tripp Platform Services is a multi-services app for shared transport (Social Riding), school bus monitoring (SchoolTripp) and estate access control and security (Sentry). Our services gives everyone the opportunity to manage their day better.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                <feature.icon className="h-8 w-8 text-green-700" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

       
    
          </div>
        </div>     
  );
};

export default About;